import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.default,
  },
  
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: theme.spacing(2, 0),
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  },

  titulo: {
    fontWeight: 700,
    color: theme.palette.text.primary,
  },

  botoesHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
  },

  dividerHeader: {
    marginBottom: theme.spacing(3),
  },

  gridFotos: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  divFoto: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    aspectRatio: '1 / 1',
    overflow: 'hidden',
    position: 'relative',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
    transition: 'transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.25s ease',
    border: `2px solid transparent`,

    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
    },

    '&:hover $fogOverlay': {
      opacity: 1,
    },

    '&:hover $checkOverlay': {
      opacity: 1,
    },

    '&:hover $infoOverlay': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },

  imagem: {
    objectFit: 'cover',
    cursor: 'pointer',
    width: '100%',
    height: '100%',
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.05)',
    },
  },

  checkOverlay: {
    position: 'absolute',
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    color: 'rgba(255, 255, 255, 0.7) !important',
    opacity: 0,
    transition: 'opacity 0.25s ease, color 0.2s ease',
    zIndex: 2,
    padding: 4,
    '& .MuiSvgIcon-root': {
      fontSize: 24,
    },
    '&.Mui-checked': {
      color: `${theme.palette.common.white} !important`,
    },
  },

  selecionada: {
    border: `2px solid ${theme.palette.primary.main}`,
    '& $fogOverlay': {
      opacity: 1,
    },
    '& $checkOverlay': {
      opacity: 1,
    },
  },

  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  galeria: {
    minHeight: '60vh',
    padding: theme.spacing(2, 0),
    alignContent: 'flex-start',
  },

  divFotoDetalhada: {
    outline: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    minWidth: '320px',
    minHeight: '240px',
  },

  fotoDetalhada: {
    maxWidth: '90vw',
    maxHeight: '90vh',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    borderRadius: '8px',
    boxShadow: theme.shadows[10],
  },

  menuSuperior: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(3),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(1.5, 3),
    backgroundColor: theme.palette.action.hover,
    borderRadius: '30px',
    border: `1px solid ${theme.palette.divider}`,
    animation: '$fadeIn 0.3s ease',
    width: 'fit-content',
    margin: '0 auto',
  },

  skeletonImagem: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    background: `linear-gradient(90deg, ${theme.palette.action.hover} 25%, ${theme.palette.action.selected} 37%, ${theme.palette.action.hover} 63%)`,
    backgroundSize: '400% 100%',
    animation: '$skeletonLoading 1.4s ease infinite',
  },

  '@keyframes skeletonLoading': {
    '0%': {
      backgroundPosition: '100% 50%',
    },
    '100%': {
      backgroundPosition: '0 50%',
    },
  },

  fogOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: 90,
    opacity: 0,
    transition: 'opacity 0.25s ease',
    background: 'linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.4) 60%, transparent 100%)',
    pointerEvents: 'none',
    zIndex: 1,
  },

  infoOverlay: {
    position: 'absolute',
    bottom: theme.spacing(1.5),
    left: theme.spacing(1.5),
    right: theme.spacing(6), // dar espaço para o checkbox
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1,
    opacity: 0,
    transform: 'translateY(10px)',
    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
  },

  textoInfo: {
    fontWeight: 600,
    color: theme.palette.common.white,
    fontSize: '0.75rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    lineHeight: 1.3,
  },

  textoInfoData: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '0.675rem',
    fontWeight: 500,
    marginTop: 2,
  },

  uploadOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.65)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
    fontSize: 12,
    fontWeight: 600,
    zIndex: 3,
    animation: '$fadeIn 0.3s ease',
  },

  uploadTexto: {
    marginTop: theme.spacing(1),
  },

  '@keyframes fadeIn': {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },

  galeriaVazia: {
    width: '100%',
    minHeight: '50vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
  },

  textoVazio: {
    fontSize: '1rem',
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },

  carrementoInicial: {
    height: '50vh',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  botoesImagemDetalhada: {
    position: 'fixed',
    bottom: theme.spacing(3),
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 10,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(1, 2),
    borderRadius: '40px',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    backdropFilter: 'blur(8px)',
    border: '1px solid rgba(255, 255, 255, 0.15)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
    
    '& .MuiIconButton-root': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      color: theme.palette.common.white,
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.25)',
        transform: 'scale(1.05)',
      },
    },
  },
}))

export default useStyles
